import styled, { useTheme } from 'styled-components';

export const EditIcon: React.FC<{ showDot?: boolean; className?: string }> = ({ showDot, className }) => {
  const theme = useTheme();
  return (
    <S.Container className={className}>
      <S.Pencil width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 7.91696V10H2.08304L8.22663 3.85641L6.14359 1.77336L0 7.91696ZM9.83752 2.24552C10.0542 2.02888 10.0542 1.67893 9.83752 1.4623L8.5377 0.162477C8.32107 -0.0541591 7.97111 -0.0541591 7.75448 0.162477L6.73795 1.179L8.821 3.26205L9.83752 2.24552Z"
          fill={theme.secondary.softBlue1}
        />
      </S.Pencil>
      {showDot && (
        <S.Dot width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="4.5" cy="4.5" r="4.5" fill="#FF4A4A" />
        </S.Dot>
      )}
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    height: 10px;
    position: relative;
    width: 10px;
  `,
  Pencil: styled.svg`
    position: absolute;
  `,
  Dot: styled.svg`
    position: absolute;
    top: -3px;
    right: -5px;
  `,
};
